let loan = {
    desirable_sum: {
        value: 50000,
    },
    desirable_period: {
        value: 12,
    },
    percent: {
        value: 2.5,
    },
    payment_per_month: {
        value: 0,
    },
};

function calculateOutput() {
    loan.payment_per_month.value = (loan.desirable_sum.value / loan.desirable_period.value);
    loan.payment_per_month.value += loan.payment_per_month.value * loan.percent.value / 100;
    if (loan.payment_per_month.output && loan.payment_per_month.output.length > 0) {
        loan.payment_per_month.output.html(loan.payment_per_month.value.toFixed(2).toCurrency());
    }
    let btn = $('.btn-modal-loan-lead');
    btn.data('desirable_sum', loan.desirable_sum.value);
    btn.data('desirable_period', loan.desirable_period.value);
    btn.data('percent', loan.percent.value);
}

for (let key in loan) {
    let variable = loan[key];
    let suffix = 'loan-' + key;

    variable['input'] = $('#input-' + suffix);
    variable['slider'] = $('#slider-' + suffix);
    variable['output'] = $('#output-' + suffix);

    variable.input.on('input change', event => {
        variable.value = event.target.value.toNumber();
        variable.input.val(variable.value.toCurrency());
        variable.slider.data('ionRangeSlider').update({
            from: variable.value,
        });
        calculateOutput();
    });

    variable.slider.on('change', event => {
        variable.value = event.target.value.toNumber();
        variable.input.val(variable.value.toCurrency());
        calculateOutput();
    });
}

if (loan.desirable_sum.slider && loan.desirable_sum.slider.length > 0) {
    loan.desirable_sum.slider.ionRangeSlider({
        type: "single",
        min: 50000,
        max: 6000000,
        step: 10000,
        grid: true,
        grid_num: 5,
        from_min: 1,
        hide_min_max: true,
        from: 50000,
        postfix: loan.desirable_sum.slider.data('suffix'),
        skin: "round",
    });
}

if (loan.desirable_period.slider && loan.desirable_period.slider.length > 0) {
    loan.desirable_period.slider.ionRangeSlider({
        type: "single",
        min: 1,
        max: 36,
        step: 1,
        grid: true,
        grid_num: 13,
        from_min: 1,
        hide_min_max: true,
        from: 12,
        postfix: loan.desirable_period.slider.data('suffix'),
        skin: "round",
    });
}

calculateOutput();